export default __webpack_public_path__ + "static/media/service--audit-e-reputation.24c2f55c.webp";